// src/features/mech/plastics/questions/PartWeightDimensionsQuestion.jsx
import React from "react";
import { Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import PerlTextField from "../../../../shared/components/PerlTextField";

export default function PartWeightDimensionsQuestion({ value, onChange }) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {
    white: "#ffffff",
    textPrimary: "#F1F2F3",
    textSecondary: "#9097A1",
  };
  const brandColor =
    theme.custom?.perlColors?.brandColor || theme.palette?.primary?.main || "#ff6034";

  // Parse the value object or initialize with empty strings
  const dimensionValue = value || {
    finishWeight: "",
    partLength: "",
    partWidth: "",
    partHeight: "",
  };

  const weightHelperText = "Enter a weight up to 20000 g.";
  const dimensionHelperText = "Enter a value up to 1000 mm.";

  const handleFieldChange = (field, newValue) => {
    onChange?.({
      ...dimensionValue,
      [field]: newValue,
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
      <PerlTextField
        label="Finish weight (g)"
        required
        type="number"
        value={dimensionValue.finishWeight || ""}
        onChange={(e) => handleFieldChange("finishWeight", e.target.value)}
        sx={{ mt: 1 }}
        helperText={weightHelperText}
        InputProps={{
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
          inputProps: { min: 0, max: 20000  }
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { color: perlColors.textPrimary },
          },
        }}
      />
      <PerlTextField
        label="Length (mm)"
        required
        type="number"
        value={dimensionValue.partLength || ""}
        onChange={(e) => handleFieldChange("partLength", e.target.value)}
        helperText={dimensionHelperText}
        InputProps={{
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
          inputProps: { min: 0, max: 1000 }
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { color: perlColors.textPrimary },
          },
        }}
      />
      <PerlTextField
        label="Width (mm)"
        required
        type="number"
        value={dimensionValue.partWidth || ""}
        onChange={(e) => handleFieldChange("partWidth", e.target.value)}
        helperText={dimensionHelperText}
        InputProps={{
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
          inputProps: { min: 0, max: 1000 }
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { color: perlColors.textPrimary },
          },
        }}
      />
      <PerlTextField
        label="Height (mm)"
        required
        type="number"
        value={dimensionValue.partHeight || ""}
        onChange={(e) => handleFieldChange("partHeight", e.target.value)}
        helperText={dimensionHelperText}
        InputProps={{
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
          inputProps: { min: 0, max: 1000 }
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { color: perlColors.textPrimary },
          },
        }}
      />
    </Box>
  );
}

